<template>
  <div class="home">
    <SlideImage></SlideImage>
    <div id="caseCon">
      <div class="case1">
        <Case class="case"></Case>
      </div>
      <div class="case2" @click="gotoProductions()">
        <CaseProductions></CaseProductions>
      </div>
    </div>
  </div>
</template>

<style scoped>
.home {
  background-color: #ffffff;
}

#caseCon {
  width: calc(100% - 32px);
  max-width: 1366px;
  padding: 32px 16px;
  overflow: hidden;
  background-color: #ffffff;
  margin: 0 auto;
}
#caseCon > .case1 {
  width: 246px;
  float: left;
}
#caseCon > .case2 {
  width: calc(100% - 246px - 16px);
  float: left;
  margin-left: 16px;
}
@media screen and (max-width: 600px) {
  #caseCon {
    margin-top: -88px;
  }
  #caseCon > .case1 {
    width: 100%;
    padding: 32px 0;
  }
  .case {
    display: block;
    margin: 0 auto;
  }
  #caseCon > .case2 {
    width: 100%;
    margin: 16px 0 0 0;
  }
}
</style>

<script>
// @ is an alias to /src
import SlideImage from "@/components/SlideImage.vue";
import Case from "@/components/Home/Case.vue";
import CaseProductions from "@/components/Home/CaseProductions.vue";

export default {
  name: "Home",
  components: {
    SlideImage,
    Case,
    CaseProductions
  },
  methods: {
    gotoProductions() {
      this.$router.push("/things");
    }
  }
};
</script>
